import React, { useState } from "react";

import {
    View,
    Text,
    TextStyle,
    TouchableOpacity,
    Linking
} from "react-native";
import AppTheme from "../../utils/Theme";
import Markdown from "../../../specific/components/Markdown/Markdown";

interface LHQTicketProps {
    goBack?: () => void
}

const LHQTicket = (props: LHQTicketProps) => {

    const appTheme: AppTheme = new AppTheme;

    const { goBack } = props;

    const [form, setForm] = useState({
        titre: "",
        description: "",
        date: "",
        email: "",
        type: "Bug",
        severite: "Bloquant",
        temporalite: "Urgent",
        fichiers: [],
    });

    const h1Style: TextStyle = {
        fontFamily: appTheme.primaryBoldFont,
        color: appTheme.darkBlue,
        fontSize: appTheme.pixelPerfectForFont(18)
    }

    const h2Style: TextStyle = {
        fontFamily: appTheme.primaryMediumFont,
        color: appTheme.darkBlue,
        fontSize: appTheme.pixelPerfectForFont(16)
    }

    const pStyle: TextStyle = {
        fontFamily: appTheme.primaryFont,
        color: appTheme.textColor,
        fontSize: appTheme.pixelPerfectForFont(14)
    }

    const aStyle: TextStyle = {
        fontFamily: appTheme.primaryFont,
        color: appTheme.textColor,
        fontSize: appTheme.pixelPerfectForFont(14),
        textDecorationLine: "underline"
    }

    const openLink = (link: string) => {
        Linking.openURL(link);
    }

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (files) {

            setForm({ ...form, [name]: Array.from(files) });
        } else {
            setForm({ ...form, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        formData.append("titre", form.titre);
        formData.append("description", form.description);
        formData.append("date", form.date);
        formData.append("email", form.email);
        formData.append("type", form.type);
        formData.append("severite", form.severite);
        formData.append("temporalite", form.temporalite);

        // Ajouter les fichiers (max 5)
        form.fichiers.forEach((file, index) => {
            formData.append(`fichier_${index}`, file);
        });

        try {
            const response = await fetch("https://n8n.lili.cool/webhook-test/10636566-5e82-4de2-a73d-1d3b5e768427", {
                method: "POST",
                headers: {
                    "API-KEY": "gTUVqoQaihQd1V1rT6WN3RTE12EZmOd6"
                },
                body: formData, // pas besoin de headers, fetch les gère
            });

            if (!response.ok) {
                throw new Error("Erreur serveur");
            }

            const result = await response.json();
        } catch (error) {
            console.error(error);
        }
    };

    const sendBug = async () => {
        try {
            const result = await fetch(
                "https://n8n.onthebeach.eu/webhook-test/10636566-5e82-4de2-a73d-1d3b5e768427",
                {
                    method: "POST",
                    headers: {
                        "API-KEY": "gTUVqoQaihQd1V1rT6WN3RTE12EZmOd6"
                    },
                    body: JSON.stringify({
                        "email": "axel@lili.cool",
                        "title": "Bug",
                        "body": "Coucou",
                        "date": new Date(),
                        "platform": "ios",
                        "version": "3.10",
                        "build": 666
                    })
                })
        } catch (error) {
            
        }
    }

    const renderForm = () => {
        return (
            <form
                onSubmit={handleSubmit}
                className="max-w-xl mx-auto p-6 space-y-6 bg-white rounded-2xl shadow"
            >
                <h1 className="text-2xl font-bold">Créer une demande</h1>

                <div className="space-y-2">
                    <label className="font-medium">Titre</label>
                    <input
                        type="text"
                        name="titre"
                        value={form.titre}
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                        required
                    />
                </div>
                <div className="space-y-2">
                    <label className="font-medium">Description</label>
                    <textarea
                        name="description"
                        value={form.description}
                        onChange={handleChange}
                        rows={4}
                        className="w-full p-2 border rounded"
                        required
                    />
                </div>

                <div className="space-y-2">
                    <label className="font-medium">Date</label>
                    <input
                        type="date"
                        name="date"
                        value={form.date}
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                        required
                    />
                </div>

                <div className="space-y-2">
                    <label className="font-medium">Email</label>
                    <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                        required
                    />
                </div>

                <div className="space-y-2">
                    <label className="font-medium">Type de demande</label>
                    <select
                        name="type"
                        value={form.type}
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                    >
                        <option>Bug</option>
                        <option>Evolution</option>
                        <option>Contenu</option>
                        <option>Documentation</option>
                    </select>
                </div>

                <div className="space-y-2">
                    <label className="font-medium">Sévérité</label>
                    <select
                        name="severite"
                        value={form.severite}
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                    >
                        <option>Bloquant</option>
                        <option>Problématique</option>
                        <option>Interface</option>
                    </select>
                </div>

                <div className="space-y-2">
                    <label className="font-medium">Temporalité</label>
                    <select
                        name="temporalite"
                        value={form.temporalite}
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                    >
                        <option>Urgent</option>
                        <option>Normal</option>
                        <option>Peut attendre</option>
                    </select>
                </div>

                <div className="space-y-2">
                    <label className="font-medium">Fichiers attachés</label>
                    <input
                        type="file"
                        name="fichiers"
                        onChange={(e) => {
                            const files = Array.from(e.target.files).slice(0, 5);
                            setForm({ ...form, fichiers: files });
                        }}
                        multiple
                        accept=".pdf,.mp3,.mp4,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
                        className="w-full p-2 border rounded"
                    />
                </div>

                <button
                    type="submit"
                    className="w-full p-3 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700"
                >
                    Envoyer
                </button>
            </form >
    }

    return <View>
        <View style={{ flexDirection: "row" }}>
            <TouchableOpacity onPress={() => goBack()}>
                <Text style={[aStyle, { fontSize: appTheme.pixelPerfectForFont(8), paddingEnd: appTheme.pixelPerfect(5) }]}>
                    Dashboard
                </Text>
            </TouchableOpacity>
            <Text style={[pStyle, { fontSize: appTheme.pixelPerfectForFont(8), paddingEnd: appTheme.pixelPerfect(5) }]}>
                {">"}
            </Text>
            <Text style={[pStyle, { fontSize: appTheme.pixelPerfectForFont(8), paddingEnd: appTheme.pixelPerfect(5) }]}>
                Ticket
            </Text>
        </View>
        <Text style={h1Style}>
            Gestion des tickets
        </Text>
        <View style={{ flexDirection: "row" }}>
                <Text style={[pStyle, { paddingEnd: appTheme.pixelPerfect(10) }]}>
                    Amplitude (Analytics)
                </Text>
                <TouchableOpacity onPress={sendBug}>
                    <Text style={aStyle}>
                       TIcket
                    </Text>
                </TouchableOpacity>
            </View>
        <View>
            {renderForm()}
            <View style={{ flexDirection: "row" }}>
                <Text style={[pStyle, { paddingEnd: appTheme.pixelPerfect(10) }]}>
                    Amplitude (Analytics)
                </Text>
                <TouchableOpacity onPress={sendBug}>
                    <Text style={aStyle}>
                        Test
                    </Text>
                </TouchableOpacity>
            </View>
        </View>
    </View>

}

export default LHQTicket;